interface IconProps {
  className?: string;
  color?: string;
}

// Blogger - Personne écrivant sur ordinateur
export function BloggerIcon({ className = "w-6 h-6", color = "#2563EB" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Écran d'ordinateur */}
      <rect x="20" y="25" width="60" height="40" fill={color} opacity="0.15" rx="3" />
      <rect x="20" y="25" width="60" height="40" fill="none" stroke={color} strokeWidth="2.5" rx="3" />

      {/* Lignes de texte sur l'écran */}
      <line x1="28" y1="35" x2="55" y2="35" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <line x1="28" y1="42" x2="65" y2="42" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <line x1="28" y1="49" x2="60" y2="49" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <line x1="28" y1="56" x2="50" y2="56" stroke={color} strokeWidth="2" strokeLinecap="round" />

      {/* Base de l'ordinateur */}
      <rect x="45" y="65" width="10" height="5" fill={color} opacity="0.3" />
      <rect x="35" y="70" width="30" height="2" fill={color} />

      {/* Crayon/Stylo qui écrit */}
      <rect x="60" y="48" width="3" height="18" fill={color} opacity="0.5" rx="1" transform="rotate(-30 62 57)" />
      <path d="M 72 60 L 69 63 L 75 65 Z" fill={color} transform="rotate(-30 72 62)" />
    </svg>
  );
}

// Conférencier - Personne avec micro devant audience
export function ConferencierIcon({ className = "w-6 h-6", color = "#9333EA" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Microphone */}
      <ellipse cx="50" cy="35" rx="8" ry="12" fill={color} opacity="0.15" />
      <ellipse cx="50" cy="35" rx="8" ry="12" fill="none" stroke={color} strokeWidth="2.5" />

      {/* Support du micro */}
      <line x1="50" y1="47" x2="50" y2="60" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M 42 60 L 58 60" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

      {/* Base arrondie sous le micro */}
      <path d="M 42 47 Q 42 52, 50 52 Q 58 52, 58 47" stroke={color} strokeWidth="2" fill="none" />

      {/* Audience (petites formes) */}
      <circle cx="25" cy="70" r="4" fill={color} opacity="0.2" />
      <circle cx="35" cy="70" r="4" fill={color} opacity="0.2" />
      <circle cx="65" cy="70" r="4" fill={color} opacity="0.2" />
      <circle cx="75" cy="70" r="4" fill={color} opacity="0.2" />

      {/* Ondes sonores */}
      <path d="M 60 30 Q 65 30, 68 35" stroke={color} strokeWidth="2" fill="none" opacity="0.4" strokeLinecap="round" />
      <path d="M 40 30 Q 35 30, 32 35" stroke={color} strokeWidth="2" fill="none" opacity="0.4" strokeLinecap="round" />
    </svg>
  );
}

// Agronome - Plante avec feuilles et sol
export function AgronomeIcon({ className = "w-6 h-6", color = "#55BC8C" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Sol/Terre */}
      <ellipse cx="50" cy="75" rx="35" ry="8" fill={color} opacity="0.15" />
      <ellipse cx="50" cy="75" rx="35" ry="8" fill="none" stroke={color} strokeWidth="2" />

      {/* Tige centrale */}
      <path d="M 50 75 Q 50 60, 50 35" stroke={color} strokeWidth="3" fill="none" strokeLinecap="round" />

      {/* Feuille gauche haute */}
      <ellipse cx="38" cy="40" rx="10" ry="14" fill={color} opacity="0.2" transform="rotate(-35 38 40)" />
      <ellipse cx="38" cy="40" rx="10" ry="14" fill="none" stroke={color} strokeWidth="2" transform="rotate(-35 38 40)" />

      {/* Feuille droite haute */}
      <ellipse cx="62" cy="45" rx="10" ry="14" fill={color} opacity="0.2" transform="rotate(35 62 45)" />
      <ellipse cx="62" cy="45" rx="10" ry="14" fill="none" stroke={color} strokeWidth="2" transform="rotate(35 62 45)" />

      {/* Feuille gauche basse */}
      <ellipse cx="35" cy="55" rx="9" ry="12" fill={color} opacity="0.2" transform="rotate(-40 35 55)" />
      <ellipse cx="35" cy="55" rx="9" ry="12" fill="none" stroke={color} strokeWidth="2" transform="rotate(-40 35 55)" />

      {/* Feuille droite basse */}
      <ellipse cx="65" cy="58" rx="9" ry="12" fill={color} opacity="0.2" transform="rotate(40 65 58)" />
      <ellipse cx="65" cy="58" rx="9" ry="12" fill="none" stroke={color} strokeWidth="2" transform="rotate(40 65 58)" />

      {/* Bourgeon au sommet */}
      <circle cx="50" cy="30" r="5" fill={color} opacity="0.3" />
      <circle cx="50" cy="30" r="5" fill="none" stroke={color} strokeWidth="2" />
    </svg>
  );
}
